<template>
  <div class="alert-page">
    <div v-if="emoji" class="emoji top-visual">{{ emoji }}</div>
    <img v-if="icon" class="top-visual" :src="require(`@/assets/icons/${icon}`)"/>
    <div class="title">{{ title }}</div>
    <div class="content">
      <slot name="content"/>
    </div>
    <div class="button" v-if="showButton">
      <riseup-button :action="buttonAction" :title="buttonTitle" :size="'small'" :disabled="buttonDisabled" :variant="buttonVariant"/>
    </div>
    <support-footer v-if="showSupportFooter" />
  </div>
</template>

<script>
import BaseUI from 'base-ui';

export default {
  name: 'AlertPage',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    SupportFooter: BaseUI.SupportFooter,
  },
  props: {
    emoji: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    showButton: {
      type: Boolean,
      default: false,
    },
    buttonAction: Function,
    buttonTitle: String,
    buttonVariant: {
      type: String,
      default: 'primary',
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
    showSupportFooter: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../scss/mixins';

  .alert-page {
    margin: 40px 30px 30px;
    text-align: center;
  }

  .emoji {
    font-size: 76px;
  }

  .top-visual {
    margin-bottom: 30px;
  }

  .title {
    @include title();
    font-weight: bold;
    margin-bottom: 12px;
  }

  .content {
    line-height: 24px;
    margin-bottom: 24px;

    .bold {
      font-weight: bold;
    }
  }

  .button {
    margin-top: 40px;
  }

</style>
